import {Component, Vue} from 'vue-property-decorator'
import RequestButton from './parts/request-button.vue';
import user_module from '@/modules/user/index';
@Component({
    components: {RequestButton}

})
export default class RequestButtonFxd extends Vue {

    fadeClass: string = 'fade-out';

    get token(){

        return user_module.token;
    }

    changeFadeClass(){

        if (this.$route.name === 'landings_pctpro'){
            this.fadeClass = 'fade-in';
            return;
        }


        if (document.documentElement.scrollTop > 400){
    
          this.fadeClass = 'fade-in';
    
        } else {
    
          this.fadeClass = 'fade-out';
        }
    
    }
    
    mounted(){
        this.changeFadeClass();
        window.addEventListener('scroll', this.changeFadeClass);
    }

    beforeDestroy(){
        window.removeEventListener('scroll', this.changeFadeClass);

    }

}